import DistributionTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/DistributionTable/DistributionTable";

export default DistributionTable;
